import Menus from './Menus';
export default Menus;
